import { AspectRatio, Box, Stack, Text } from '@chakra-ui/react';
import { Routes } from '@constants/routes';
import useSSRDate from '@hooks/useSSRDate';
import Image from 'next/image';
import Link from 'next/link';

const Card = ({ post }) => {
  const { formattedDate } = useSSRDate(post.publishedAt);

  return (
    <Link href={`${Routes.articles}/${encodeURIComponent(post.slug)}`}>
      <Box
        h="100%"
        bg="white"
        display="flex"
        flexDir="column"
        gap={1}
        cursor="pointer"
        borderRadius={8}
        overflow="hidden"
        boxShadow="0px 0px 6px 0px #0000001A"
        sx={{
          ':hover': { opacity: 0.6 },
          transition: 'opacity 200ms ease-in-out',
        }}
      >
        <AspectRatio position="relative" minWidth={['100px', '100px', '160px']} height="180px">
          <Image alt={post.coverImage.title} src={post.coverImage.imageUrl} width={500} height={500} />
        </AspectRatio>
        <Stack spacing={1} p={3}>
          <Text
            fontSize={14}
            fontWeight={500}
            color="gray.500"
            sx={{
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
            }}
          >
            {formattedDate}
          </Text>
          <Text
            overflow="hidden"
            textOverflow="ellipsis"
            display="-webkit-box"
            sx={{
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
            }}
            fontWeight={600}
            textStyle="p"
          >
            {post.title}
          </Text>
          {post.subTitle && (
            <Text
              fontSize={16}
              overflow="hidden"
              textOverflow="ellipsis"
              display="-webkit-box"
              sx={{
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
              }}
            >
              {post.subTitle}
            </Text>
          )}
        </Stack>
      </Box>
    </Link>
  );
};

export default Card;
